import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableBody,
} from '@mui/material';

import { Chip } from '../../../components/common';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../components/common/Table';
import { downloadBase64Attachment } from '../../../utils/utils';

export default function IncomeTable(props) {
  const incomeSum = Number(
    (
      props.data?.directPaymentIncome +
      props.data?.cropProductionIncome +
      props.data?.animalProductionIncome +
      props.data?.additionalIncome
    ).toFixed(2)
  );
  return (
    <>
      <Grid container sx={{ mt: 4 }}>
        <Grid item xs={12} ref={props.cropsStructureTableRef}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="incomeTable">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Źródło dochodu</StyledTableCell>
                  <StyledTableCell align="center">
                    Kwota dochodu(zł)
                  </StyledTableCell>
                  <StyledTableCell align="center">% Dochodu</StyledTableCell>
                  <StyledTableCell align="center">Załączniki</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    Dopłaty
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(props.data?.directPaymentIncome.toFixed(2)) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(
                      (
                        (props.data?.directPaymentIncome / incomeSum) *
                        100
                      ).toFixed(2)
                    ) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.incomes?.loanCropIncomeResponses[0]?.file !==
                      null && (
                      <Chip
                        label={
                          props.incomes?.loanCropIncomeResponses[0].fileName
                        }
                        onClick={() =>
                          downloadBase64Attachment(
                            props.incomes?.loanCropIncomeResponses[0].file,
                            props.incomes?.loanCropIncomeResponses[0]
                              .fileExtension,
                            props.incomes?.loanCropIncomeResponses[0].fileName
                          )
                        }
                      />
                    )}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    Produkcja roślinna
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(props.data?.cropProductionIncome.toFixed(2)) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(
                      (
                        (props.data?.cropProductionIncome / incomeSum) *
                        100
                      ).toFixed(2)
                    ) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.incomes?.loanCropIncomeResponses[0]?.file !==
                      null && (
                      <Chip
                        label={
                          props.incomes?.loanCropIncomeResponses[0].fileName
                        }
                        onClick={() =>
                          downloadBase64Attachment(
                            props.incomes?.loanCropIncomeResponses[0].file,
                            props.incomes?.loanCropIncomeResponses[0]
                              .fileExtension,
                            props.incomes?.loanCropIncomeResponses[0].fileName
                          )
                        }
                      />
                    )}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    Produkcja zwierzęca
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(props.data?.animalProductionIncome.toFixed(2)) ||
                      ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {' '}
                    {Number(
                      (
                        (props.data?.animalProductionIncome / incomeSum) *
                        100
                      ).toFixed(2)
                    ) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.incomes?.loanAnimalIncomeResponseList.map(
                      (e, index) => {
                        if (e.file !== null) {
                          return (
                            <Chip
                              label={e.fileName}
                              key={e.fileName + index}
                              onClick={() =>
                                downloadBase64Attachment(
                                  e.file,
                                  e.fileExtension,
                                  e.fileName
                                )
                              }
                              sx={{
                                '&:not(:last-child)': {
                                  mr: 1,
                                },
                              }}
                            />
                          );
                        } else return null;
                      }
                    )}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row">
                    Pozostałe
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(props.data?.additionalIncome.toFixed(2)) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {Number(
                      (
                        (props.data?.additionalIncome / incomeSum) *
                        100
                      ).toFixed(2)
                    ) || ''}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {props.incomes?.loanAdditionalIncomeResponses.map(
                      (e, index) => {
                        if (e.file !== null) {
                          return (
                            <Chip
                              label={e.fileName}
                              key={e.fileName + index}
                              onClick={() =>
                                downloadBase64Attachment(
                                  e.file,
                                  e.fileExtension,
                                  e.fileName
                                )
                              }
                              sx={{
                                '&:not(:last-child)': {
                                  mr: 1,
                                },
                              }}
                            />
                          );
                        } else return null;
                      }
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid
          item
          xs={12}
          container
          justifyContent="right"
          alignContent="right"
        >
          <Grid item xs={3} sx={{ my: 4 }}>
            <TableContainer>
              <Table sx={{ width: '100%' }}>
                <TableHead>
                  <TableRow
                    style={{ boxShadow: '0px 1px 18px rgba(0, 0, 0, 0.12)' }}
                  >
                    <StyledTableCell
                      variant="head"
                      style={{
                        borderRadius: '6px 0px 0px 6px',
                        width: '50%',
                      }}
                    >
                      Suma dochodu (zł)
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        borderRadius: '0px 6px 6px 0px',
                        width: '50%',
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        color: '#000000',
                      }}
                    >
                      {incomeSum || '-'}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
